import React from "react";

const VerifySuccess = () => (
  <div style={{ padding: "2rem", textAlign: "center" }}>
    <h2>✅ Your email has been verified successfully!</h2>
    <p>You may now log in to your account.</p>
  </div>
);

export default VerifySuccess;

